import React from "react";

import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { makeStyles, createStyles, Chip, Theme } from "@material-ui/core";
import clsx from "clsx";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    badge: {
      marginLeft: theme.spacing(0.4),
      padding: theme.spacing(0.25),
      backgroundColor: "rgba(255,255,255,0.6)",
      fontSize: "0.7rem",
      color: theme.palette.text.secondary,
      borderRadius: 8,
    },
    chip: {
      // backgroundColorはPropsのclassNameでの上書きを前提とする
      backgroundColor: "",
      "&:hover": {
        backgroundColor: "",
      },
      "&:focus": {
        backgroundColor: "",
      },
      borderRadius: "6px",
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
  })
);

interface Props {
  text: string;
  expand: boolean;
  expandable: boolean;
  count: number;
  showCount: boolean;
  showZero: boolean;
  onExpand: () => void;
  onShrink: () => void;
  className?: string;
}

/** 基本語彙チップ */
export function BasewordChip(props: Props) {
  const classes = useStyles();

  const {
    text,
    expand,
    expandable,
    count,
    showCount,
    showZero,
    onExpand,
    onShrink,
    className,
  } = props;

  const handleClick = () => {
    if (expand) {
      // 折りたたむ
      onShrink();
    } else {
      // 展開する
      onExpand();
    }
  };

  // 件数バッジ取得
  const getBadge = (): React.ReactNode => {
    let elem = <></>;
    if (showCount) {
      if (count !== 0 || showZero) {
        // カウントが0でshowZeroがtrueの場合以外、
        // 件数バッジ要素を設定する
        elem = <span className={classes.badge}>{count}</span>;
      }
    }
    return elem;
  };

  // 展開、折りたたみアイコン取得
  const getIcon = () => {
    if (expandable) {
      return expand ? <ExpandLess /> : <ExpandMore />;
    }
    return <></>;
  };

  return (
    <Chip
      label={(
        <span>
          <span>{text}</span>
          {getBadge()}
        </span>
      )}
      size="small"
      className={clsx(classes.chip, className)}
      onClick={handleClick}
      onDelete={handleClick}
      deleteIcon={getIcon()}
    />
  );
}
